export default "__VITE_ASSET__DKa_UANR__"